import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody } from "reactstrap";

/**
 * Общий блок «объект недоступен» — единый вид для 404-страницы, отказа по ролям
 * и ошибок детальных страниц (не найдено / нет прав / сервер вернул ошибку).
 *
 * До этого компонента 404, 403 и 5xx выглядели одинаково с «данных нет»: список
 * просто оставался пустым, а оператор не мог отличить отказ от пустоты.
 * Компонент чисто презентационный — данные и действия передаёт страница.
 *
 * @param {string} icon        имя иконки `mdi mdi-*` без префикса (напр. "mdi-lock-outline")
 * @param {string} tone        bootstrap-цвет иконки: danger | warning | muted | secondary
 * @param {node}   code        крупный код (например «404») над заголовком
 * @param {node}   title       заголовок состояния
 * @param {node}   description пояснение — что произошло и что делать
 * @param {node}   children    дополнительные детали (перечень ролей, код ошибки и т.п.)
 * @param {node}   actions     кнопки/ссылки выхода из состояния
 * @param {string} className   дополнительные классы карточки
 */
const ResourceErrorState = ({
  icon = "mdi-alert-circle-outline",
  tone = "danger",
  code,
  title,
  description,
  children,
  actions,
  className = "",
}) => (
  <Card className={`text-center ${className}`.trim()}>
    <CardBody className="py-5">
      <i
        className={`mdi ${icon} text-${tone} d-block`}
        style={{ fontSize: "3rem", lineHeight: 1 }}
        aria-hidden="true"
      />
      {code ? <div className="fw-bold text-muted mt-2 font-size-24">{code}</div> : null}
      <h4 className="mt-3 mb-2">{title}</h4>
      {description ? <p className="text-muted mb-0">{description}</p> : null}
      {children ? <div className="mt-3">{children}</div> : null}
      {actions ? (
        <div className="d-flex flex-wrap justify-content-center gap-2 mt-4">{actions}</div>
      ) : null}
    </CardBody>
  </Card>
);

ResourceErrorState.propTypes = {
  icon: PropTypes.string,
  tone: PropTypes.string,
  code: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.node,
  className: PropTypes.string,
};

export default ResourceErrorState;
